import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

import { components } from 'components/ui/select';

const ContactSelectMenuEmptyState = props => (
  <components.Menu {...props}>
    <div className="d-flex flex-column align-items-center text-center px-4 py-5">
      <h5 className="mt-0 text-muted">
        <FontAwesomeIcon className="me-4" icon={faUser} />
        <FontAwesomeIcon icon={faBriefcase} />
      </h5>

      <div className="mb-4">
        {props.description}
      </div>

      <div className="controls">
        <a
          aria-label="new"
          className="clickable"
          onClick={() => props.selectProps.onCreateClick(props.selectProps.inputValue)}
        >
          + Create new {props.selectProps.contactTypeLabel}
        </a>
      </div>
    </div>
  </components.Menu>
);

ContactSelectMenuEmptyState.propTypes = {
  description: PropTypes.string.isRequired,
  selectProps: PropTypes.shape({
    contactTypeLabel: PropTypes.string.isRequired,
    inputValue: PropTypes.string,
    onCreateClick: PropTypes.func.isRequired
  })
};

export default ContactSelectMenuEmptyState;
